import { useEffect, useRef } from 'react'
import { EventBusActionType, EventBusEntityType, eventBusUtil } from 'src/util/event-bus-util'

/**
 * Stripe sends the user back to `/profile/personal/success` once checkout
 * completes (see backend `success_url`). That redirect is the only browser-side
 * signal that a subscription was created, so the GA / Meta / PostHog purchase
 * events hang off it via SUBSCRIPTION.CREATE.
 */
export const useCheckoutReturn = (params: { checkoutStatus?: string }): void => {
  const { checkoutStatus } = params
  const hasEmitted = useRef(false)

  useEffect(() => {
    if (checkoutStatus !== 'success' || hasEmitted.current) return
    hasEmitted.current = true

    eventBusUtil().emit({
      action: EventBusActionType.CREATE,
      entity: EventBusEntityType.SUBSCRIPTION,
      meta: {},
    })
  }, [checkoutStatus])
}
